export function conversionRate(before) {
    if (before === 0 || before === 'NaN') {
      return 'level';
    } else if (before < 0) {
      return 'down';
    } else {
      return 'up';
    }
  }